/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    code: "code",
    em: "em",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "DrawerList Properties"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Properties"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "data"
            }), " or ", _jsx(_components.code, {
              children: "children"
            })]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(required)"
            }), " the data we want to fill the list with. Provide the data as a ", _jsx(_components.code, {
              children: "JSON string"
            }), ", ", _jsx(_components.code, {
              children: "array"
            }), " or ", _jsx(_components.code, {
              children: "object"
            }), " in these ", _jsx(_components.a, {
              href: "/uilib/components/fragments/drawer-list/info#data-structure",
              children: "data structure"
            }), ". ", _jsx("br", {}), " If you don't have to define a ", _jsx(_components.code, {
              children: "value"
            }), ", you can also send in a ", _jsx(_components.code, {
              children: "function"
            }), " which will be called once the user opens the DrawerList."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "value"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " define a preselected data entry (index). Should either be an index (integer) of the data array or a key – defined by ", _jsx(_components.code, {
              children: "selectedKey"
            }), " (the deprecated ", _jsx(_components.code, {
              children: "selected_key"
            }), " should not start with a number) inside an array item. Or if ", _jsx(_components.code, {
              children: "data"
            }), " is an object, use the object key as the ", _jsx(_components.code, {
              children: "value"
            }), " to define the selected item. Can be a string or integer."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "default_value"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if you want to define only a startup value (integer) or have to handle a re-render without handling the state during the re-render by yourself, then using ", _jsx(_components.code, {
              children: "default_value"
            }), " is a good choice. Defaults to ", _jsx(_components.code, {
              children: "null"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "triangle_position"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " position of arrow icon/triangle inside the drawer-list. Set to ", _jsx(_components.code, {
              children: "left"
            }), " or ", _jsx(_components.code, {
              children: "right"
            }), ". Defaults to ", _jsx(_components.code, {
              children: "left"
            }), " if not set."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "direction"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines the direction of how the drawer-list shows the options list. Can be ", _jsx(_components.code, {
              children: "bottom"
            }), " or ", _jsx(_components.code, {
              children: "top"
            }), ". Defaults to ", _jsx(_components.code, {
              children: "auto"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "prevent_selection"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " If set to ", _jsx(_components.code, {
              children: "true"
            }), ", the DrawerList will then not make any permanent selection. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "focusable"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " If set to ", _jsx(_components.code, {
              children: "true"
            }), ", the element is then focusable by assertive technologies."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "prevent_close"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " If set to ", _jsx(_components.code, {
              children: "true"
            }), ", the DrawerList will not close on any events. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "keep_open"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " If set to ", _jsx(_components.code, {
              children: "true"
            }), ", the DrawerList will close on outside clicks, but not on selection. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "independent_width"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " If set to ", _jsx(_components.code, {
              children: "true"
            }), ", the DrawerList will handle it's width and position handling independent to the parent/mother element. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "fixed_position"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " If set to ", _jsx(_components.code, {
              children: "true"
            }), ", the DrawerList will be fixed in it's scroll position by using CSS ", _jsx(_components.code, {
              children: "position: fixed;"
            }), ". Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "enable_body_lock"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " If set to ", _jsx(_components.code, {
              children: "true"
            }), ", the HTML body will get locked from scrolling when the Dropdown is open. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "skip_keysearch"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " If set to ", _jsx(_components.code, {
              children: "true"
            }), ", search items by the first key will be ignored. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "ignore_events"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " If set to ", _jsx(_components.code, {
              children: "true"
            }), ", all keyboard and mouse events will be ignored. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "align_drawer"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " use ", _jsx(_components.code, {
              children: "right"
            }), " to change the options alignment direction. Makes only sense to use in combination with ", _jsx(_components.code, {
              children: "prevent_selection"
            }), " or ", _jsx(_components.code, {
              children: "more_menu"
            }), " - or if a independent width is used. Defaults to ", _jsx(_components.code, {
              children: "left"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "list_class"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " define a HTML class that will be set on the list, beside ", _jsx(_components.code, {
              children: "dnb-drawer-list__list"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "portal_class"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " define a HTML class that will be set on the DOM portal beside ", _jsx(_components.code, {
              children: "dnb-drawer-list__portal__style"
            }), ". Can be useful to handle e.g. a custom ", _jsx(_components.code, {
              children: "z-index"
            }), " in relation to a header."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "scrollable"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines if the options list should be scrollable (the ", _jsx(_components.code, {
              children: "max-height"
            }), " is set by default to ", _jsx(_components.code, {
              children: "50vh"
            }), "). Defaults to ", _jsx(_components.code, {
              children: "true"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "no_scroll_animation"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " to disable scrolling animation. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "no_animation"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " to disable appear/disappear (show/hide) animation. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "skip_portal"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " to disable the React Portal behavior. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "min_height"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines if the minimum height (in ", _jsx(_components.code, {
              children: "rem"
            }), ") of the options list. Defaults to ", _jsx(_components.code, {
              children: "10rem"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "max_height"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines if the maximum height (in ", _jsx(_components.code, {
              children: "rem"
            }), ") of the options list. Defaults to ", _jsx(_components.code, {
              children: "null"
            }), ", as this is set automatically by default."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "page_offset"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines if the available scrollable height. If scrolling not should change the height of the drawer-list, then set it to ", _jsx(_components.code, {
              children: "0"
            }), " (useful if the DrawerList is used in fixed positions on contrast to a scrollable page content). Defaults to ", _jsx(_components.code, {
              children: "window.pageYOffset"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "observer_element"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " set a HTML element, either as a selector or a DOM element. Can be used to send in an element which will be used to make the ", _jsx(_components.em, {
              children: "direction calculation"
            }), " on."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "cache_hash"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " set a ", _jsx(_components.code, {
              children: "cache_hash"
            }), " as a string to enable internal memorizing of the list to enhance rerendering performance. Components like Autocomplete is using this because of the huge data changes due to search and reorder. Defaults to ", _jsx(_components.code, {
              children: "null"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "wrapper_element"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " has to be a HTML Element, ideal a mother element, used to calculate sizes and distances. Also used for the \"click outside\" detection. Clicking on the ", _jsx(_components.code, {
              children: "wrapper_element"
            }), " will not be anymore triggered as an outside click."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "options_render"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " has to be a function, returning the items again. See ", _jsx(_components.a, {
              href: "/uilib/components/fragments/drawer-list#example-usage-of-options_render",
              children: "example"
            }), ". This can be used to add additional options above the actual rendered list."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/uilib/layout/space/properties",
              children: "Space"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " spacing properties like ", _jsx(_components.code, {
              children: "top"
            }), " or ", _jsx(_components.code, {
              children: "bottom"
            }), " are supported."]
          })]
        })]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
